import { CanActivateFn } from '@angular/router';
import { userRouteAccessGuard } from '../core/auth/user-route-access.guard';

/**
 * Access guard for /ordermanagement.
 *
 * Two very different callers land on this same route:
 *  1. Opening the Order Organizer directly — requires the `order.management.show` feature
 *     (declared in the route's `data.features`, enforced below via {@link userRouteAccessGuard}).
 *  2. A SAP checklist deep-link — `#/ordermanagement?Order=...,Node=...,Station=...` — which is a
 *     PASS-THROUGH: AppMainComponent reads the `Order` param and immediately redirects the operator
 *     into the checklist (`/checklist/:task`, which enforces its own access). Shop-floor operators
 *     must be able to play these WITHOUT `order.management.show`, since that feature would also
 *     unlock the Order Organizer, which they should not have.
 *
 * The parent shell route already enforces authentication (`microsoftOrUserGuard`), so for the
 * pass-through case we simply let the authenticated user through; the real gate for what they can
 * play sits on the `/checklist` route they're redirected to.
 */
export const orderManagementRouteGuard: CanActivateFn = (route, state) => {
  if (route.queryParamMap.has('Order')) {
    return true; // SAP deep-link pass-through → AppMainComponent redirects to /checklist
  }
  return userRouteAccessGuard(route, state); // Organizer → require order.management.show (route.data)
};
